import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ExpiredPage.css';

const ExpiredPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [reason, setReason] = useState('trial'); // 'trial' | 'suspended'

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const code = params.get('reason');
        if (code === 'suspended') setReason('suspended');
        else setReason('trial');
    }, [location.search]);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    const isSuspended = reason === 'suspended';

    return (
        <div className="expired-page">
            {/* Fondo animado */}
            <div className="expired-bg">
                <div className="expired-orb orb-1" />
                <div className="expired-orb orb-2" />
                <div className="expired-orb orb-3" />
            </div>

            <div className="expired-card">
                {/* Icono */}
                <div className={`expired-icon-wrapper ${isSuspended ? 'suspended' : 'trial'}`}>
                    <span className="expired-icon">{isSuspended ? '🔒' : '⏰'}</span>
                </div>

                {/* Texto principal */}
                <div className="expired-content">
                    <h1 className="expired-title">
                        {isSuspended ? 'Cuenta Suspendida' : 'Período de Prueba Finalizado'}
                    </h1>
                    <p className="expired-subtitle">
                        {isSuspended
                            ? 'Tu cuenta ha sido suspendida por el administrador del sistema.'
                            : 'Tu período de prueba gratuito de 30 días ha concluido.'}
                    </p>

                    {/* Mensaje de acción */}
                    <div className="expired-cta-box">
                        <p className="expired-cta-text">
                            {isSuspended
                                ? 'Para reactivar tu acceso, comunícate con soporte.'
                                : 'Para continuar usando el ERP y no perder tus datos, activa tu plan.'}
                        </p>

                        {/* Contacto WhatsApp */}
                        <a
                            href="https://wa.me/51963152294?text=Hola%2C%20necesito%20reactivar%20mi%20cuenta%20del%20ERP"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="expired-btn-whatsapp"
                        >
                            <svg viewBox="0 0 24 24" className="wa-icon" fill="currentColor">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.124 1.531 5.858L0 24l6.335-1.509A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.006-1.374l-.36-.213-3.76.896.958-3.662-.234-.375A9.818 9.818 0 0112 2.182c5.421 0 9.818 4.397 9.818 9.818 0 5.422-4.397 9.818-9.818 9.818z" />
                            </svg>
                            Contactar por WhatsApp
                        </a>
                    </div>

                    {/* Features recordatorio */}
                    {!isSuspended && (
                        <div className="expired-features">
                            <p className="expired-features-title">Tu información sigue segura:</p>
                            <ul className="expired-features-list">
                                <li>✅ Todos tus datos están guardados</li>
                                <li>✅ Historial de ventas completo</li>
                                <li>✅ Clientes y productos intactos</li>
                                <li>✅ Acceso inmediato al activar</li>
                            </ul>
                        </div>
                    )}
                </div>

                {/* Footer con logout */}
                <div className="expired-footer">
                    <button onClick={handleLogout} className="expired-btn-logout">
                        Cerrar Sesión
                    </button>
                    <p className="expired-legal">
                        ¿Problemas? Escríbenos y te ayudamos en minutos.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ExpiredPage;
